import React from 'react';
import { useCallSelector, usePhoneActions } from '../../hooks/use-phone';
import { CallInboundView } from './call-inbound-view';

export default function CallInbound(props: { callId: string }) {
    const remoteIdentity = useCallSelector(props.callId, x => x.remoteIdentity) || '';
    const { answer, hangup, ignoreCall } = usePhoneActions();

    return (
        <CallInboundView
            phoneNumber={remoteIdentity}
            onIgnore={() => ignoreCall(props.callId)}
            onAnswer={() => answer(props.callId)}
            onHangup={() => hangup(props.callId)}
        />
    );
}
